module.exports = __webpack_public_path__ + "static/bluewhalemain-69a3e66a3811fdb9fcaf30ae4d9bf432.png";